module.exports = __webpack_public_path__ + "public/img/w3.76ffab01.png";